import React from 'react';
import { StickyNavigation } from '@latitude/sticky-navigation';
import { TabNavigation } from '@latitude/tab-navigation';

export default props => {
  return (
    <StickyNavigation
      isVisible
      noShadow
      headerMinified={props.headerMinified}
      offsetElem="[data-sticky-navigation-offset]"
    >
      <TabNavigation
        basepath="/digital-wallets"
        data={[
          {
            id: '/apple-pay/',
            label: 'Apple Pay',
            img: 'apple-pay.svg'
          },
          {
            id: '/google-pay/',
            label: 'Google Pay',
            img: 'google-pay.svg'
          },
          {
            id: '/garmin-pay/',
            label: 'Garmin Pay',
            img: 'garmin-pay.svg'
          }
        ].map(item => {
          item.img = require(`./images/${item.img}`);
          return item;
        })}
      />
    </StickyNavigation>
  );
};
